import React from 'react';
import VendorDocumentsButton from './VendorDocumentsButton';
import LegacyEntityDocumentsButton from './LegacyEntityDocumentsButton';

// Lifecycle V2 currently supports Vendors only. Preserve the V1 implementation
// byte-for-byte for PO, Maintenance Task and Asset integrations.
export default function EntityDocumentsButton(props) {
  return props.entityType === 'vendor'
    ? <VendorDocumentsButton {...props} />
    : <LegacyEntityDocumentsButton {...props} />;
}
